import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import { QueryClient, QueryClientProvider } from 'react-query'

const appQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0
        }
    }
})

const AppView = (
    <Provider store={store}>
        <QueryClientProvider client={appQueryClient}>
            <App />
        </QueryClientProvider>
    </Provider>
)

ReactDOM.render(AppView, document.getElementById('root'))
